import HorizontalLogo from '@/components/common/HorizontalLogo';

const HomeMessage = () => {
  return (
    <div className="flex flex-col items-center p-2">
      <HorizontalLogo />
      <h1 className="text-2xl font-bold text-center mb-2">
        Find the perfect Pro for your next adventure
      </h1>
    </div>
  );
};

export default HomeMessage;
